/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/

import { Box } from "@mui/material";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import GeneralSettingsDataContent from "components/content/GeneralSettingsDataContent";
import { useTranslation } from "react-i18next";

/**
 * General System Settings Page
 * 
 * Dedicated page for managing system-wide general settings.
 * Accessible only to ADMIN and ROOT users via the Configurator drawer.
 * 
 * Features:
 * - Direct editable form (no modal)
 * - Country, Language, Currency configuration
 * - Module toggles (Insurance, Pharmacy)
 * - System mode settings (Simplified)
 * - Default appointment duration
 * - Videochat enabled time
 * 
 * @returns General settings management page with full-size editable form
 */
const GeneralSettingsPage = () => {
    const { t } = useTranslation();

    return (
        <DefaultDashboardLayout>
            <Box className="full-form-wrapper">
                <Box className="full-form-sub-wrapper">
                    <GeneralSettingsDataContent />
                </Box>
            </Box>
        </DefaultDashboardLayout>
    );
}
export default GeneralSettingsPage;
